import React from "react";
import Fallback from "../../components/Fallback";

const ProfileLayout = React.lazy(() => import("./ProfileLayout"));
const YourProfile = React.lazy(() => import("./YourProfile"));
export const ProfileLayoutScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <ProfileLayout {...props} />
  </React.Suspense>
);
export const YourProfileScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <YourProfile {...props} />
  </React.Suspense>
);
